import { computed } from "mobx";
import type { ProductInfoModel } from "../../../OpenApi/api";
import { IEnvironmentStore } from "../environments/EnvironmentStore";
import { ICountryStore } from "../country/CountryStore";

export interface IProductInfoStore {
	readonly version: string;
	readonly productReleaseDate: string;
	readonly manualsRevisionDate: string;
	readonly softwareIdentificationNumber: string;
	readonly baseUrl: string;
	readonly mprUrl: string;
	readonly softwareManagementUrl: string;
	readonly softwareManagementApplicationNamePacsonwebApp: string;
	readonly defaultLanguage: string;
	readonly maximumMemorySize: number;
	readonly isDemoEnvironment: boolean;
	readonly isMedicalDevice: boolean;
}

export class ProductInfoStore implements IProductInfoStore {
	public readonly version: string;
	public readonly productReleaseDate: string;
	public readonly manualsRevisionDate: string;
	public readonly softwareIdentificationNumber: string;
	public readonly baseUrl: string;
	public readonly mprUrl: string;
	public readonly softwareManagementUrl: string;
	public readonly softwareManagementApplicationNamePacsonwebApp: string;
	public readonly defaultLanguage: string;
	public readonly maximumMemorySize: number;
	public readonly isDemoEnvironment: boolean;

	constructor(
		productInfo: ProductInfoModel,
		private readonly environmentStore: IEnvironmentStore,
		private readonly countryStore: ICountryStore,
	) {
		this.version = productInfo.version;
		this.productReleaseDate = productInfo.productReleaseDate;
		this.manualsRevisionDate = productInfo.manualsRevisionDate;
		this.softwareIdentificationNumber = productInfo.softwareIdentificationNumber;
		this.baseUrl = productInfo.baseUrl;
		this.mprUrl = productInfo.mprUrl;
		this.softwareManagementUrl = productInfo.softwareManagementUrl;
		this.softwareManagementApplicationNamePacsonwebApp = productInfo.softwareManagementApplicationNamePacsonwebApp;
		this.defaultLanguage = productInfo.defaultLanguage;
		this.maximumMemorySize = productInfo.maximumMemorySize;
		this.isDemoEnvironment = productInfo.isDemoEnvironment ?? false;
	}

	@computed
	public get isMedicalDevice() {
		const { currentEnvironment } = this.environmentStore;
		const { currentCountry } = this.countryStore;

		const environmentIsMedicalDevice = currentEnvironment?.medicalDevice ?? true; //when environment was not found -> use true
		const countryIsMedicalDevice = currentCountry?.medicalDevice ?? true; // when country was not found -> use true

		//both should be true to define a medical device
		return environmentIsMedicalDevice && countryIsMedicalDevice;
	}
}
